




































/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaMenu from "@/Ui-Components/Common/ParticaMenu/ParticaMenu.vue";
import ContentSelector from "@/Ui-Components/Content/ContentSelectorDrag.vue";
import PageTurner from "@/Ui-Components/Issue/PageTurner.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";

import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";
import { PageContent, PageContentItem, PageBox, ExtractionProperties, LoadPageContent } from "../../../Models/Components.model";
import { Rect, IssueModel, ArticleModel, MenuItemDTO, ArticleImageModel, SectionModel } from "../../../Generated/ParticaAPI";
import { PdfContentService, IPdfContentService } from "../../../BusinessServices/issuecontent";
import { IssueService, IIssueService } from "../../../BusinessServices/issue";
import { ArrayUtils } from "../../../BusinessServices/arrayutils";
import { Position } from "vue-router/types/router";
import { ArticleImage, IExtractedArticle, Article } from "../../../Models/ArticleModels/article";
import { eParticaAction, getActionName, ParticaEvent } from "../../../Models/ParticaEvent";
import ParticaArticleExtract from "@/Ui-Components/Article/Extracted/ParticaArticleExtract.vue";
import { IViewerArticleService } from "../../../BusinessServices/viewerarticles";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../../Models/Buttons";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { ISectionService } from "../../../BusinessServices/section";

@Component(
	{
		name: "IssueExtraction",
		components: {
			ParticaError,
			ParticaRowContainer,
			ParticaColumnContainer,
			ContentSelector,
			PageTurner,
			ParticaMenu,
			ParticaArticleExtract,
			ButtonList,
			ParticaView
		}
	})
export default class IssueExtraction extends ParticaIssueBase {
	@Prop() private id: number;
	private issue: IssueModel | null = null;
	private pdfContentService: IPdfContentService;
	private issueService: IIssueService;
	private viewerArticleService: IViewerArticleService;
	private sectionService: ISectionService;
	private pageNumber: number = 1;
	private content: PageContent | null = null;
	private article: IExtractedArticle = new Article() as IExtractedArticle;
	private width: number = 700;
	private sections: SectionModel[] = [];

	private buttons: ButtonConfig[] = [
		{
			label: "Save Article",
			action: eParticaAction.ARTICLE_SAVE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.PAGE_CHANGE: {
					this.pageNumber = event.item as number;
					await this.loadPageContent(this.pageNumber);
					break;
				}
				case eParticaAction.ARTICLE_SAVE: {
					this.article.issueId = this.id;
					this.article = await this.viewerArticleService.saveArticle(this.article);
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	private checkImage(image: any) {
		const img: ArticleImage = new ArticleImage();
		img.src = image.attrs.src.substring(image.attrs.src.lastIndexOf("/") + 1);
		img.src = img.src.replace(/.600.jpg/gi, `.jpg`);
		const found: any = this.article.images.find(x => x.src === img.src);
		if (found === undefined) {
			this.article.addImage(img as ArticleImage);
		}
	}


	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Extract Articles";
		this.pdfContentService = this.particaServices.getPdfContentService();
		this.issueService = this.particaServices.getIssueService();
		this.viewerArticleService = this.particaServices.getViewerArticleService();
		this.sectionService = this.particaServices.getSectionService();
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getIssueNav(this.id);
			this.issue = await this.issueService.getIssue(this.id);
			if (this.navData.parentId !== undefined) {
				this.sections = await this.sectionService.getSections(this.navData.parentId);
			}
			await this.loadPageContent(this.pageNumber);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}

	private async loadPageContent(pageNumber: number) {
		try {
			this.LoadingStart();
			this.content = await this.pdfContentService.getPageContent(this.id, pageNumber, LoadPageContent.All);
			if (this.issue != null) {
				this.content.src = `${this.stateconfig.thumburl}${this.issue.guid}/thumb/${this.pageNumber}.1200.jpg`;
			}
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}


}
